<template>
  <Adminlte>
      <div class="box box-primary center-block">
        <div class="box-header with-border">
          <i class="fa fa-table font-dark"></i>
          <h3 class="box-title">Exportação de dados - Questionários</h3>
        </div>

        <section class="content">
          <div class="row main-row">
            <div class="col-xs-12 col-md-6">
              <div class="inner-box">
                <ParksFilter :parks="parks" :disabled="isDownloading" />
              </div>
            </div>
            <div class="col-xs-12 col-md-6">
              <div class="inner-box">
                <h4>Ano do Questionário</h4>
                <div class="form-group">
                  <div class="center-inside-col">
                    <select v-model="selectedYear" class="form-control year-select" :disabled="isDownloading">
                      <option v-if="availableYears.length === 0" :value="null" disabled>
                        Carregando anos…
                      </option>
                      <option v-for="year in availableYears" :key="year" :value="year">{{ year }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <button
                class="btn btn-block btn-success"
                @click="handleDownloadClick('original')"
                :disabled="isDownloading || selectedParksIds.length === 0"
              >
                Baixar Excel (formato original)
                <i class="fa fa-refresh fa-spin" v-if="waitingDownload === 'original'"></i>
              </button>

              <button
                class="btn btn-block btn-primary readable-export-btn"
                @click="handleDownloadClick('readable')"
                :disabled="isDownloading || selectedParksIds.length === 0"
                title="Abas por eixo e coleções em formato longo (1 linha por item)"
              >
                Baixar Excel legível
                <i class="fa fa-refresh fa-spin" v-if="waitingDownload === 'readable'"></i>
              </button>

              <p class="export-hint">
                A versão legível organiza as respostas por eixo e coloca coleções
                (equipe, investimentos, âncoras etc.) em tabelas com uma linha por item.
              </p>
            </div>
          </div>
        </section>
      </div>
    </Adminlte>
</template>

<script>
  import Adminlte from '@/components/template/Adminlte'
  import ParksFilter from './ParksFilter'
  import ParkClient from '@/services/resource_client/park'
  import { BackendApi } from '@/services/backend_api'
  import { saveAs } from 'file-saver'

  export default {
    name: 'ExportParkQuiz',
    components: { Adminlte, ParksFilter },
    data: function () {
      return {
        parks: [],
        selectedYear: null,
        waitingDownload: null,
        parksWithApprovedQuizPerYear: {}
      }
    },
    async mounted () {
      this.parksWithApprovedQuizPerYear = await this.getParksWithApprovedParkQuizPerYear()
      if (this.availableYears.length > 0) {
        this.selectedYear = this.availableYears[0]
      }
    },
    methods: {
      async getParksWithApprovedParkQuizPerYear () {
        const response = await ParkClient.withApprovedParkQuizPerYear()
        return response.data || {}
      },
      handleDownloadClick (variant) {
        const queryParams = {
          parks: this.selectedParksIds.join(','),
          year: this.selectedYear
        }

        const path = variant === 'readable'
          ? '/spreadsheet/park-quiz/readable'
          : '/spreadsheet/park-quiz'
        const filename = variant === 'readable'
          ? `park-quiz-readable_${this.selectedYear}.xlsx`
          : `park-quiz_${this.selectedYear}.xlsx`

        this.waitingDownload = variant
        BackendApi.getClient().get(path, {
          params: queryParams, responseType: 'blob'
        }).then((response) => {
          saveAs(response.data, filename)
        }).finally(() => {
          this.waitingDownload = null
        })
      }
    },
    watch: {
      selectedYear (currentSelectedYear) {
        this.parks = []

        if (!currentSelectedYear) {
          return
        }

        const parksWithApprovedQuizInSelectedYear = this.parksWithApprovedQuizPerYear[currentSelectedYear] || []
        parksWithApprovedQuizInSelectedYear.forEach(park => {
          this.parks.push({...park, 'isSelected': true})
        })
      }
    },
    computed: {
      availableYears: function () {
        return Object.keys(this.parksWithApprovedQuizPerYear).sort().reverse()
      },
      isDownloading: function () {
        return this.waitingDownload !== null
      },
      selectedParksIds: function () {
        return this.parks.filter((park) => park.isSelected).map((park) => park.id)
      }
    }
  }
</script>

<style scoped>
  .inner-box {
    background-color: #488ab3;
    box-shadow: 0px 1px 5px #888888;
    padding: 10px;
    margin-bottom: 15px;
    color: white;
  }
  .year-select {
    color: #333;
    background-color: #fff;
  }
  .readable-export-btn {
    margin-top: 10px;
  }
  .export-hint {
    color: #555;
    font-size: 12px;
    line-height: 1.4;
    margin-top: 12px;
  }
</style>



// WEBPACK FOOTER //
// ExportParkQuiz.vue?430f2ab6